import React from 'react';
import { Box, Text } from '@razorpay/blade/components';
import { CustomFieldsDisplayProps } from './types';
import { formatFieldValue, isEmptyFieldValue } from './utils';

/**
 * 30% right-aligned key | 70% value, thin row separators inside a bordered
 * container. Text roles follow the V1 `.table__style--key-value` tables this
 * widget sits between on employeeDetail.php (sass/elements/_tables.scss): key
 * in normal/medium, value in subtle.
 */
export const CustomFieldsDisplay = ({ definitions, values }: CustomFieldsDisplayProps) => {
  const visible = definitions.filter((def) => def.effectiveAccess !== 'HIDDEN');
  return (
    <Box
      display="flex"
      flexDirection="column"
      backgroundColor="surface.background.gray.intense"
      paddingY="spacing.3"
      borderColor="surface.border.gray.subtle"
      borderWidth="thin">
      {visible.map((def, index) => {
        const fieldKey = def.fieldKey ?? '';
        const value = values[fieldKey];
        const isLastRow = index === visible.length - 1;

        return (
          <Box
            key={fieldKey}
            display="flex"
            flexDirection="row"
            borderBottomColor={isLastRow ? undefined : 'surface.border.gray.subtle'}
            borderBottomWidth={isLastRow ? undefined : 'thin'}>
            <Box width="30%" padding="spacing.4" textAlign="right">
              <Text color="surface.text.gray.normal" weight="medium">
                {def.label}
              </Text>
            </Box>
            <Box width="70%" padding="spacing.4">
              <Text
                color={
                  isEmptyFieldValue(value) ? 'surface.text.gray.muted' : 'surface.text.gray.subtle'
                }>
                {formatFieldValue(def, value)}
              </Text>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};
